import type { Treatment } from '../types';

export const TREATMENTS: Treatment[] = [
  {
    id: 'consulta',
    label: 'Consulta Dermatológica',
    icon: 'ri-stethoscope-line',
    message: 'Olá, Dra. Laura! Gostaria de agendar uma *Consulta Dermatológica*. Poderia me informar a disponibilidade de horários? 😊',
  },
  {
    id: 'procedimentos',
    label: 'Pequenos Procedimentos',
    icon: 'ri-scissors-cut-line',
    message: 'Olá, Dra. Laura! Gostaria de agendar uma avaliação para *Pequenos Procedimentos* (remoção de lesões). Qual a disponibilidade? 😊',
  },
  {
    id: 'estetica',
    label: 'Tecnologias e Medicina Estética',
    icon: 'ri-magic-line',
    message: 'Olá, Dra. Laura! Tenho interesse em *Tecnologias e Medicina Estética* e gostaria de agendar uma avaliação. Qual a disponibilidade? 😊',
  },
  {
    id: 'clinica',
    label: 'Dermatologia Clínica',
    icon: 'ri-heart-pulse-line',
    message: 'Olá, Dra. Laura! Gostaria de agendar uma consulta de *Dermatologia Clínica*. Poderia me informar os horários disponíveis? 😊',
  },
  {
    id: 'acne',
    label: 'Tratamento de Acne',
    icon: 'ri-drop-line',
    message: 'Olá, Dra. Laura! Gostaria de agendar uma consulta para *Tratamento de Acne*. Poderia me informar os horários disponíveis? 😊',
  },
  {
    id: 'melasma',
    label: 'Melasma e Manchas',
    icon: 'ri-sun-line',
    message: 'Olá, Dra. Laura! Tenho interesse no tratamento de *Melasma e Manchas* e gostaria de agendar uma avaliação. Qual a disponibilidade? 😊',
  },
  {
    id: 'cancer',
    label: 'Prevenção ao Câncer de Pele',
    icon: 'ri-shield-check-line',
    message: 'Olá, Dra. Laura! Gostaria de agendar uma consulta para *Prevenção ao Câncer de Pele* com dermatoscopia. Qual a disponibilidade? 😊',
  },
  {
    id: 'outro',
    label: 'Outro Tratamento',
    icon: 'ri-question-line',
    message: 'Olá, Dra. Laura! Gostaria de agendar uma consulta e tirar algumas dúvidas sobre tratamentos. Poderia me informar os horários disponíveis? 😊',
  },
];

export const LOCAL_UNITS = [
  { id: 'criciumia' as const, label: 'Criciúma', sub: 'KASA DERMA', icon: 'ri-map-pin-2-line' },
  { id: 'tubarao' as const, label: 'Tubarão', sub: 'Grupo Naiana SA', icon: 'ri-map-pin-2-line' },
];
